import React from "react";
import { SearchInput } from "../shared";
import DateRangeField from "../atoms/DateRangeField";

/**
 * Molekül: Ödemeler listelerinin arama + tarih aralığı satırı (#242).
 * Arama da tarih alanları gibi etiketli ve aynı yükseklikte (40px) — alt
 * kenarlar hizalı durur. ListToolbar `search` slotuna verilir.
 */
export default function SearchDateFilters({
  search,
  onSearchChange,
  placeholder,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end gap-2 w-full sm:w-auto">
      <div className="w-full sm:w-80">
        <label className="block text-xs sm:text-sm font-medium text-gray-500 mb-1 sm:mb-1.5">
          Ara
        </label>
        <SearchInput
          placeholder={placeholder}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="h-10 !py-0 sm:!py-0 !rounded-lg"
          title={placeholder}
        />
      </div>
      <DateRangeField
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        size="sm"
        zIndex={10050}
        className="flex flex-col sm:flex-row gap-2 [&>div]:sm:w-44"
      />
    </div>
  );
}
